<template>
  <!-- 操作履歴検索 -->
  <div id="AppHistorySearch">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">操作履歴検索</label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="検索期間" labelPosition="on-border">
              <b-datepicker
                v-model="startDate"
                name="startDate"
                placeholder="検索開始年月日"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              >
                <button
                    class="button is-danger"
                    @click="(startDate = null)"
                  >
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </button>
              </b-datepicker>
              <b-datepicker
                v-model="endDate"
                name="endDate"
                placeholder="検索終了年月日"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              >
                <button
                    class="button is-danger"
                    @click="(endDate = null)"
                  >
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="利用者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffCode"
                name="staffCode"
                data-vv-as="利用者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="利用者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffName"
                name="staffName"
                data-vv-as="利用者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="送信元" labelPosition="on-border">
              <b-select expanded v-model="searchConditions.accessType" v-on:input="selectOffice()">
                <option value></option>
                <option value="ブラウザ">ブラウザ</option>
                <option value="iPad">iPad</option>
              </b-select>
            </b-field>
          </div>
          <!-- <div class="columns">
          <div class="column is-one-third">
            <b-field label="IPアドレス" labelPosition="on-border">
              <b-input
                v-model="searchConditions.ipAddr"
                name="ipAddr"
                data-vv-as="IPアドレス"
                type="text"
              ></b-input>
            </b-field>
          </div>-->
          <div class="column is-one-third">
            <b-field label="操作内容" labelPosition="on-border">
              <b-input
                v-model="searchConditions.operation"
                name="operation"
                data-vv-as="操作内容"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="健康状態" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.healthStatus"
                id="check1"
                native-value="1"
              >良好</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.healthStatus"
                id="check0"
                native-value="0"
              >不良</b-checkbox-button>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span style="color: red" v-if="isSearchConditionNull">検索条件を指定してください。</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <section>
      <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
        <div class="columns">
          <div class="column is-two-thirds" style="text-align:left;">
            <b-button
              class="button is-primary has-text-centered"
              icon-left="download"
              native-type="button"
              v-on:click="downloadPlan"
            >ダウンロード</b-button>
          </div>
          <div class="column">
            <b-field horizontal label="検索結果" style="float:right; white-space:nowrap;">
              <b-select position="is-right" v-model="perPage">
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div>
          <b-table
            :data="data"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="date"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="date" label="日時" sortable centered>{{ format(props.row.date) }}</b-table-column>
              <b-table-column
                field="staffName"
                label="利用者"
                sortable
                centered
              >{{ getRowItem(props.row.staffName,20) }}</b-table-column>
              <!-- <b-table-column field="ipAddr" label="IPアドレス" sortable centered>{{ props.row.ipAddr }}</b-table-column> -->
              <b-table-column
                field="accessType"
                label="送信元"
                sortable
                centered
              >{{ props.row.accessType }}</b-table-column>
              <b-table-column field="function" label="業務" sortable centered>{{ props.row.function }}</b-table-column>
              <b-table-column field="screen" label="画面" sortable centered>{{ props.row.screen }}</b-table-column>
              <b-table-column
                field="operation"
                label="操作"
                sortable
                centered
              >{{ getRowItem(props.row.operation,150) }}</b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </section>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
var data = [];
export default {
  name: "AppHistorySearch",
  methods: {
    format(date) {
      return date.substring(0, date.length - 4);
    },
    getRowItem: function(value, length) {
      return value.length > length ? value.substr(0, length) + "..." : value;
    },
    search: function(searchConditions) {
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(searchConditions.staffCode) ||
        this.isLength(searchConditions.staffName) ||
        this.isLength(searchConditions.ipAddr) ||
        this.isLength(searchConditions.operation) ||
        searchConditions.healthStatus.length > 0
      ) {
        console.log("検索条件あり");
        this.isSearchConditionNull = false;
        // 検索条件の整形
        if (this.startDate && !(typeof this.startDate == "string")) {
          this.searchConditions.periodstart = this.formatDate(this.startDate);
        }
        if (this.endDate && !(typeof this.endDate == "string")) {
          this.searchConditions.periodend = this.formatDate(this.endDate);
        }
        var excuteApi = this.getOperationHistoryListPOST;
        var successCallBack = this.getOperationHistoryListSuccess;
        var errorCallBack = this.getOperationHistoryListError;
        // WebAPI Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
      }
    },
    getOperationHistoryListPOST: function(client) {
      var healthChecks;
      var req = {
        startDate: this.searchConditions.periodstart,
        endDate: this.searchConditions.periodend,
        staffCode: this.searchConditions.staffCode,
        staffName: this.searchConditions.staffName,
        ipAddr: this.searchConditions.ipAddr,
        operation: this.searchConditions.operation,
        accessType: this.searchConditions.accessType
      };

      if (this.searchConditions.healthStatus.length > 0) {
        healthChecks = parseInt(this.searchConditions.healthStatus[0]);
        if (this.searchConditions.healthStatus.length >= 2) {
          healthChecks = 2;
        }
        req["healthStatus"] = healthChecks;
      }
      return client.apis.apiCommon.getOperationHistoryListPOST({
        body: req
      });
    },
    getOperationHistoryListSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
    },
    getOperationHistoryListError: function(result) {
      this.showErrorMessage(result);
    },
    downloadPlan: function(event) {
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.ipAddr) ||
        this.isLength(this.searchConditions.operation) ||
        this.searchConditions.healthStatus.length > 0
      ) {
        console.log("ダウンロード条件あり");
        // 検索条件の整形
        if (this.startDate && !(typeof this.startDate == "string")) {
          this.searchConditions.periodstart = this.formatDate(this.startDate);
        }
        if (this.endDate && !(typeof this.endDate == "string")) {
          this.searchConditions.periodend = this.formatDate(this.endDate);
        }
        var excuteApi = this.downloadOperationHistoryTextFilePOST;
        var errorCallBack = this.downloadOperationHistoryTextFileError;
        // WebAPI Call
        this.downloadApiCall(excuteApi, errorCallBack);
      } else {
        console.log("ダウンロード条件未入力");
        this.showErrorMessage("ダウンロード条件を指定してください。");
      }
    },
    downloadOperationHistoryTextFilePOST: function(client) {
      var healthChecks;
      var req = [];
      if (this.searchConditions.healthStatus.length <= 0) {
        req = {
          startDate: this.searchConditions.periodstart,
          endDate: this.searchConditions.periodend,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          ipAddr: this.searchConditions.ipAddr,
          operation: this.searchConditions.operation
        };
      } else {
        healthChecks = parseInt(this.searchConditions.healthStatus[0]);
        if (this.searchConditions.healthStatus.length >= 2) {
          healthChecks = 2;
        }
        req = {
          startDate: this.searchConditions.periodstart,
          endDate: this.searchConditions.periodend,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          ipAddr: this.searchConditions.ipAddr,
          healthStatus: healthChecks,
          operation: this.searchConditions.operation
        };
      }
      return client.apis.apiCommon.downloadOperationHistoryTextFilePOST({
        body: req
      });
    },
    downloadOperationHistoryTextFileError: function(result) {
      this.showErrorMessage(result);
    }
  },
  data() {
    return {
      data,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 100,
      searchConditions: {
        periodstart: "",
        periodend: "",
        staffCode: "",
        staffName: "",
        ipAddr: "",
        operation: "",
        healthStatus: [],
        accessType: ""
      },
      isSearchConditionNull: false,
      startDate: null,
      endDate: null
    };
  },
  filters: {},
  components: {},
  mounted: function() {
    // WebApi Call
    this.search(this.searchConditions);
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppHistorySearch.vue